import { typeToKey, unitsTypes } from '../constants/dashboards';
import { aggregationTypes } from '../constants/event';
import { clearEmptyFilterClauses } from './compound';

const validStr = (str) => str.trim() !== '';

const validateTemplate = (templateName, templateDescription) => {
  if (!validStr(templateName)) {
    throw new Error('Name of template is empty');
  }
  if (!validStr(templateDescription)) {
    throw new Error('Description is empty');
  }
};

export const validation = (setErrorMessage, templateName, templateDescription, onExec) => {
  try {
    validateTemplate(templateName, templateDescription);
    onExec(templateName, templateDescription);
  } catch (e) {
    setErrorMessage(e.message);
  }
};

const validateDashboard = (dashboard) => {
  if (!validStr(dashboard.name)) {
    throw new Error('Required field Name is empty');
  }
};

export const validationDashboard = (setErrorMessage, dashboard, onExec) => {
  try {
    validateDashboard(dashboard);
    onExec(dashboard);
  } catch (e) {
    setErrorMessage(e.message);
  }
};

const groupTemplates = (res = [], template) => {
  let resVar = res;

  resVar = resVar || [];
  const e = resVar.find(({ type }) => type === template.type);
  const o = e
    ? { ...e, templates: [...e.templates, template] }
    : { type: template.type, templates: [template] };

  return [...resVar.filter((s) => s !== e), o];
};

export const getTemplatesByDashboard = (dashboard, templates) =>
  dashboard.templates
    // Ставится в соответствие id темплейта с объектом темплейта, если темплейта нету c таким id то он фильтруется.
    .filter((idTemplate) => templates[idTemplate] !== undefined)
    // Ставится в соответствие id темплейта с объектом темплейта,
    .map((idTemplate) => templates[idTemplate])
    // группируем темплейты по типу.
    .reduce(groupTemplates, [])
    // сортируем темплейты по типу.
    .sort((a, b) => a.type.localeCompare(b.type))
    .flatMap(({ templates: templatesArray }) =>
      // сортируем темплейты внутри каждой группы по алфавиту.
      templatesArray.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
    );

const SEPARATOR = ':';

export const filterQueriesByTemplate = (key, idTemplate) =>
  Number(key.split(SEPARATOR)[2]) === Number(idTemplate);

export const composeKey = (...arrKey) => arrKey.join(SEPARATOR);

export const findByKeys = (obj, ...keys) => {
  const key = keys.map(String).join(SEPARATOR);

  return Object.entries(obj)
    .filter(([objKeys]) => objKeys.startsWith(key))
    .map(([, val]) => val);
};

function isNotValidEventsField(eventsUnit) {
  if (!eventsUnit.groupColumn) return true;

  return eventsUnit.events.some((e) => {
    if (!e.name) return true;

    return (
      (e.aggregationType.includes(aggregationTypes.SUM) ||
        e.aggregationType.includes(aggregationTypes.AVG_TOTAL) ||
        e.aggregationType.includes(aggregationTypes.AVG_TOTAL_SPLIT)) &&
      !e.aggregationColumn
    );
  });
}

function isNotValidFunnelFields(funnel) {
  return funnel.steps.some((step) => {
    const isValid = !step.enabled || step.event;
    return !isValid;
  });
}

export const validateUnits = (units) => {
  return !units.some((u) => {
    if (!u.name) return true;

    switch (u.type) {
      case unitsTypes.EVENTS_TYPE:
        return isNotValidEventsField(u.compose[typeToKey[u.type]]);
      case unitsTypes.RETENTION_COMPLEX_TYPE:
        return (
          !u.compose[typeToKey[u.type]].firstEvent || !u.compose[typeToKey[u.type]].returnEvent
        );
      case unitsTypes.USERS_TYPE:
        return !u.compose[typeToKey[u.type]].event;
      case unitsTypes.FUNNELS_TYPE:
        return isNotValidFunnelFields(u.compose[typeToKey[u.type]].funnel);

      default:
        return false;
    }
  });
};

// функция для трансформации полей optional и filter шагов воронки при сохранении дашборда
export const transformFunnelUnit = (unit) => ({
  ...unit,
  compose: {
    ...unit.compose,
    funnels: {
      ...unit.compose.funnels,
      funnel: clearEmptyFilterClauses(unit.compose.funnels.funnel),
    },
  },
});
